import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { selectProgramType } from 'legacy/lut/features/partner360/configuration'
import { updateSectionSettings } from 'legacy/lut/features/partner360/sectionSettings'
import { IClientSectionSettings } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'
import { selectIsPowerServicesParticipant } from 'legacy/lut/features/partner360/sectionSettings/selectors/selectIsPowerServicesParticipant'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export const usePowerServicesMembershipParticipant = () => {
  /** -------------------- Variables ----------------------- */
  const dispatch = useAppDispatch()
  const isPowerServicesMembershipParticipant = useSelector(selectIsPowerServicesParticipant)
  const programType = useSelector(selectProgramType)
  const [isPowerServicesParticipant, setIsParticipant] = useState(
    isPowerServicesMembershipParticipant
  )
  const [isLoading, setIsLoading] = useState(false)

  /** -------------------- Methods ----------------------- */
  const changePowerServicesMembershipParticipationStatus = useCallback(
    async (newState: boolean) => {
      setIsParticipant(newState)
      setIsLoading(true)

      const valueToUpdate = newState ? 1 : 0
      const sectionSettingsField =
        programType === ProgramTypes.CorePrint
          ? 'CorePrintPowerServicesMembershipParticipant'
          : 'PersonalSystemsPowerServicesMembershipParticipant'

      const settingsToUpdate = {
        [sectionSettingsField]: valueToUpdate,
      } as Partial<IClientSectionSettings>

      await dispatch(
        updateSectionSettings({
          sectionSettings: settingsToUpdate,
          flag: sectionSettingsField,
          state: valueToUpdate,
          controlName: 'Planning',
        })
      ).unwrap()

      setIsLoading(false)
    },
    [dispatch, programType]
  )

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    setIsParticipant(isPowerServicesMembershipParticipant)
  }, [isPowerServicesMembershipParticipant])

  return {
    isLoading,
    isPowerServicesParticipant,
    setPowerServicesParticipant: changePowerServicesMembershipParticipationStatus,
  }
}
